var React = require('react');

function CalendarWhite (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd"},[React.createElement("rect",{"width":"16","height":"13","x":"1","y":"3","stroke":"#FFF","className":"stroke-colored-el","strokeWidth":"2","rx":"3","key":0}),React.createElement("path",{"fill":"#FFF","className":"fill-colored-el","d":"M4 0h1v4H4zM13 0h1v4h-1zM5 7h8v1H5zM5 11h6v1H5z","key":1})]));
}

CalendarWhite.defaultProps = {"width":"18","height":"17"};

module.exports = CalendarWhite;

CalendarWhite.default = CalendarWhite;
